var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3959 49.25V21.8953C18.3959 21.343 18.8436 20.8953 19.3959 20.8953H33.0464C33.5986 20.8953 34.0464 21.343 34.0464 21.8953V49.25M18.3959 49.25L18.4001 36.507C18.4003 35.9546 17.9526 35.5067 17.4001 35.5067H3.75C3.19772 35.5067 2.75 35.9544 2.75 36.5067V48.25C2.75 48.8023 3.19772 49.25 3.75 49.25H18.3959ZM18.3959 49.25H34.0464M34.0464 49.25V3.75C34.0464 3.19771 34.4941 2.75 35.0464 2.75H48.25C48.8023 2.75 49.25 3.19771 49.25 3.75V48.25C49.25 48.8023 48.8023 49.25 48.25 49.25H34.0464Z",
    stroke: "#00A1E4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon (1).c858a8d2593bdfc0139467970716981f.svg";
export { ForwardRef as ReactComponent };